import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFoundPage.scss';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate('/');
  };

  return (
    <div className="not-found-page">
      <div className="not-found-page__container">
        <div className="not-found-page__content">
          <h1 className="not-found-page__404">404</h1>
          <h2 className="not-found-page__title">OPPS! PAGE NOT FOUND</h2>
          <p className="not-found-page__message">
            Sorry, the page you're looking for doesn't exist.<br/>
            The page you are looking for might have been moved, renamed, or might never existed.
          </p>
          <div className="not-found-page__actions">
            <button 
              className="not-found-page__button not-found-page__button--primary"
              onClick={handleReturnHome}
            >
              RETURN HOME
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;

